(function () {
  document.querySelectorAll('.ranking-track').forEach(function (track) {
    if (track.dataset.sliderReady) return; // 二重初期化防止
    track.dataset.sliderReady = '1';
    var VISIBLE_PC     = parseInt(track.dataset.visiblePc, 10)     || 3;
    var VISIBLE_MOBILE = parseInt(track.dataset.visibleMobile, 10)  || 2;
    var GAP      = parseInt(track.dataset.gap, 10)      || 10;
    var GAP_SP   = parseInt(track.dataset.gapSp, 10)   || GAP;
    var INTERVAL = parseInt(track.dataset.interval, 10) || 3000;
    var DURATION = 350;
    var BREAKPOINT = 768;

    function getVisible() {
      return window.innerWidth < BREAKPOINT ? VISIBLE_MOBILE : VISIBLE_PC;
    }

    function getGap() {
      return window.innerWidth < BREAKPOINT ? GAP_SP : GAP;
    }

    var originals = Array.from(track.querySelectorAll('.ranking-card'));
    if (originals.length === 0) return;

    // PC表示枚数分のクローンを末尾に追加（PC/スマホ両方のシームレスループに対応）
    var cloneCount = VISIBLE_PC;
    for (var i = 0; i < cloneCount; i++) {
      track.appendChild(originals[i % originals.length].cloneNode(true));
    }

    var allCards = Array.from(track.querySelectorAll('.ranking-card'));
    var LOOP_IDX = originals.length;
    var idx = 0;

    function calcCardWidth() {
      var containerW = track.parentElement.getBoundingClientRect().width || track.parentElement.offsetWidth;
      var v = getVisible();
      return (containerW - getGap() * (v - 1)) / v;
    }

    function setCardWidths() {
      var w = calcCardWidth();
      allCards.forEach(function (c) { c.style.width = w + 'px'; });
    }

    // アニメーションなしで指定インデックスへ瞬間移動
    function snapTo(i) {
      var w = calcCardWidth();
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (i * (w + getGap())) + 'px)';
      // getBoundingClientRect() で同期的に forced reflow → transition:none が確実に適用される
      void track.getBoundingClientRect();
      track.style.transition = 'transform ' + DURATION + 'ms ease-in-out';
    }

    // 1枚スライド
    function step() {
      idx++;
      var w = calcCardWidth();
      track.style.transform = 'translateX(-' + (idx * (w + getGap())) + 'px)';
      // クローン領域に入ったら先頭へリセット
      if (idx >= LOOP_IDX) {
        setTimeout(function () { idx = 0; snapTo(0); }, DURATION + 50);
      }
    }

    setCardWidths();
    snapTo(0);
    setInterval(step, INTERVAL);

    // リサイズ時にカード幅と位置を再計算
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setCardWidths();
        snapTo(idx);
      }, 100);
    });
  });
})();
